export interface SelectionBounds {
  startTime: number;
  duration: number;
}

export function timeToAbsolutePixel(
  time: number,
  videoDuration: number,
  stripWidth: number
): number {
  if (videoDuration <= 0) return 0;
  return (time / videoDuration) * stripWidth;
}

export function constrainSelectionTime(
  time: number,
  duration: number,
  videoDuration: number
): number {
  return Math.max(0, Math.min(videoDuration - duration, time));
}
